const WORLD_MAP = 'http://gis.hongyikeji.com:8090//iserver/services/map-China100/rest/maps/China/tileFeature/vectorstyles.json?type=MapBox_GL&styleonly=true';
const COLLIERY_MAP_TEMPLATE = 'http://gis.hongyikeji.com:8090/iserver/services/map-{NAME}/rest/maps/{NAME}/tileFeature/vectorstyles.json?type=MapBox_GL&styleonly=true';

const ZOOM_WORLD_MIN = 0;
const ZOOM_WORLD_MAX = 15;
const ZOOM_WORLD_DEFAULT = 4;
const ZOOM_HOME_MAX = 10;

const ZOOM_COLLIERY_MIN = 12;
const ZOOM_COLLIERY_MAX = 20.5;
const ZOOM_COLLIERY_DEFAULT = 14;

const MAP_BG_TINT_COLOR = '#FFFFFF';
const MAP_BG_DEEP_COLOR = "#022D5B";
const MAP_URL_REPLACE = "http://gis.hongyikeji.com:81";
//const ZOOM_COLLIERY_DATA_MIN = 14;// 显示煤矿数据的级别

// 显示工作面内信息的级别
const ZOOM_FACE_MIN = 15;

// Set bounds to China
const BOUNDS_WORLD = [
    [52, 3], // Southwest coordinates，西南坐标
    [156, 54]  // Northeast coordinates，东北坐标
];

const CENTER_WORLD = [107.807231, 35.265208];

export default{
    MAP_BG_TINT_COLOR,
    MAP_BG_DEEP_COLOR,

    WORLD_MAP,
    COLLIERY_MAP_TEMPLATE,
    ZOOM_FACE_MIN,
    ZOOM_COLLIERY_MIN,
    ZOOM_COLLIERY_MAX,
    ZOOM_COLLIERY_DEFAULT,
    ZOOM_WORLD_MIN,
    ZOOM_WORLD_MAX,
    ZOOM_WORLD_DEFAULT,
    ZOOM_HOME_MAX,
    BOUNDS_WORLD,
    CENTER_WORLD,
    MAP_URL_REPLACE
}



// WEBPACK FOOTER //
// ./src/constants/map.constants.js